exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cep-bulk-processing-container .input--message-error {\n  display: block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/cepbulkprocessing/index.less
// module id = 3373
// module chunks = 0